import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useFormik } from "formik";
import { getErrorMessage, isError } from "libs/utils/form";
import queryString from "query-string";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  clearLoginAsyncState,
  forgot_password,
  forgot_password_check,
} from "redux/modules/authSlice";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(./assets/images/bg-login.png), linear-gradient(to bottom left, ${theme.palette.primary.main}, #00c2cb 45%, ${theme.palette.secondary.main})`,
    objectFit: "cover",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundBlendMode: "screen",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 3px 17px 0 rgba(44, 40, 40, 0.11)",

    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 25,
    paddingButton: 45,
    flex: 1,
    borderRadius: 10,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  logo: {
    display: "flex",
    alignSelf: "center",
    width: 300,
    margin: theme.spacing(4),
  },
  title: {
    fontSize: 42,
    color: "#003b5c",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: 50,
    backgroundColor: "#11cdef",
    alignSelf: "center",
  },
  offlineLogin: {
    alignSelf: "center",
  },
  loading: {
    marginRight: theme.spacing(1),
  },
  line: {
    marginTop: 8,
    height: 3,
    width: 50,
    backgroundColor: "#11cdef",
  },
}));

export default function ForgotPasswordPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const search = useLocation().search;
  const queryParams = queryString.parse(search);
  const id = encodeURIComponent(queryParams.UserID);

  const { isLoading, isSuccess, isFailure } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    dispatch(clearLoginAsyncState());
  }, [dispatch]);

  useEffect(() => {
    if (!isLoading && isSuccess) {
      dispatch(clearLoginAsyncState());
      history.replace("/logout");
    }
  }, [isSuccess, isLoading, history, dispatch, isFailure]);

  const validationSchema = yup.object({
    // email: yup
    //   .string()
    //   .required("Email is required")
    //   .email("Email is invalid format"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      email: "",
      password: "",
      repassword: "",
    },
    isInitialValid: false,
    onSubmit: async (values) => {
      if (id != "undefined" && id != null) {
        const data = {
          userID: id,
          password: values.password,
          repassword: values.repassword,
        };
        // console.log(data);
        if (values.password == values.repassword) {
          dispatch(forgot_password_check(data));
        } else {
          alert("Password not match");
        }
      } else {
        const data = {
          email: values.email,
        };
        // console.log(data);
        dispatch(forgot_password(data));
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className={classes.root}>
        <Container maxWidth="sm">
          <Card className={classes.paper}>
            <CardContent className={classes.content}>
              <Typography variant="h4" className={classes.title}>
                Forgot Password
              </Typography>
              <Typography variant="h6">Smart VISA Service</Typography>
              <div className={classes.line} />
              <img
                alt="smart-visa"
                src="/assets/images/logo.png"
                className={classes.logo}
              />

              {id === "undefined" || id == null ? (
                <TextField
                  label="Email"
                  variant="outlined"
                  style={{
                    marginTop: 5,

                    borderRadius: "5px",
                  }}
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("email", formik)}
                  helperText={getErrorMessage("email", formik)}
                />
              ) : (
                <>
                  <TextField
                    label="Password"
                    variant="outlined"
                    style={{
                      marginTop: 5,

                      borderRadius: "5px",
                    }}
                    name="password"
                    type="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("password", formik)}
                    helperText={getErrorMessage("password", formik)}
                  />
                  <TextField
                    label="Re-Password"
                    variant="outlined"
                    style={{
                      marginTop: 5,

                      borderRadius: "5px",
                    }}
                    name="repassword"
                    type="password"
                    value={formik.values.repassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("repassword", formik)}
                    helperText={getErrorMessage("repassword", formik)}
                  />
                </>
              )}

              <Button
                variant="contained"
                color="secondary"
                size="large"
                className={classes.submit}
                disabled={isLoading}
                type="submit"
                //   href={oneLoginURL}
              >
                {isLoading && (
                  <CircularProgress
                    color="secondary"
                    className={classes.loading}
                    size={18}
                  />
                )}
                Send
              </Button>

              <Button
                color="secondary"
                size="small"
                className={classes.offlineLogin}
                fullWidth={false}
                disabled={isLoading}
                to="/login_draft"
                component={Link}
                //   onClick={handleClickOffline}
              >
                Back To Login
              </Button>
            </CardContent>
          </Card>
        </Container>
      </div>
    </form>
  );
}
